 angular
     .module('vppApp')
     .factory('GetAuthDetailsService', function() {

         var savedData = {
             submitData: {
                 programID: null,
                 programCode: null,
                 authDetails: {},
                 relationship: null,
                 moduleDetails: {},
                 emailAddress: null,
                 secondaryPassword: null,
                 purchaserFirstName: null,
                 purchaserLastName: null            
             },
             accountInfo: {},
             fields: {
                 hasContacted: 'Y',
                 relationship: '',
                 programName: '',
                 programCode: '',
                 zipCode: null,
                 emailAddress: '',
                 birthDate: null,
                 range: '',
                 year: '2016'
             },
             standardGovCopy: true,
             authTemplateType: null,
             partnerName: null,
             subsidiaryName: null,
             termsAndConditions: null
         };
         
         var authSuccessfull = false;
         
         var resetData = angular.copy(savedData);

         function set(data) {
             savedData = data;
         }
         function get() {
             return savedData;
         }
         function resetAuthData() {
           var _tempResetAuthData = angular.copy(resetData);
           savedData = angular.extend( savedData, _tempResetAuthData );
           authSuccessfull = false;
         }
         function getSuccessfull() {
           return authSuccessfull;
         }
         function setAuthSuccess() {
           authSuccessfull = true;
         }

         return {
             set: set,
             get: get,
             resetAuthData: resetAuthData,
             getSuccessfull: getSuccessfull, 
             setAuthSuccess: setAuthSuccess
         };

     });
